<app-small-tuile
  type="icon"
  icon="fa-kit fa-picto-constance"
  [title]="'dashboard.water_level' | translate"
  [mode]="
    this.actionStack!.getValue('coPConsigneRegulation') +
    '%' +
    ' (Consigne : ' +
    this.actionStack!.getValue('coPConsigneRegulation') +
    '%)'
  "
  (onPress)="this.openProductModal()"
  [content]="buttons[this.actionStack!.getValue('coCModeFonctionnement')].icon!"
  [color]="buttons[this.actionStack!.getValue('coCModeFonctionnement')].color!"
  [status]="
    buttons[this.actionStack!.getValue('coCModeFonctionnement')].statusTitle!
      | translate
  "
  [statusMode]="
    buttons[this.actionStack!.getValue('coCModeFonctionnement')].status!
  "
>
</app-small-tuile>
